import axios from "axios";

const attendanceAPI = axios.create({
  baseURL: "https://missionmap-lc.onrender.com/api/attendance",
});

attendanceAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default attendanceAPI;
